import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { IUser } from '@/features/user/store/user.model';
import { useBusinessUserInformationProps } from '@/features/kyc/hooks/useBusinessUserInformationProps';
import { TBusinessSectionKey } from '@/features/kyc/store/types/business.types';
import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';

interface IMainInformation {
  user: IUser;
  isSectionOnEdition: (key: TBusinessSectionKey) => boolean;
  isSectionEditable: (key: TBusinessSectionKey) => boolean;
  toogleSectionEditMode: (key: TBusinessSectionKey) => void;
}

export function BusinessMainInformation({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IMainInformation) {
  const { t } = useTranslation();

  const isMainInformationOnEdition = isSectionOnEdition('mainInformation');
  const isContactOnEdition = isSectionOnEdition('contact');

  const {
    mainInformation,
    isMainInformationInvalid,
    isLoading,
    isContactInvalid,
    contact,
    onUpdateUser,
    onCancelEdition,
  } = useBusinessUserInformationProps({
    user,
    isMainInformationOnEdition,
    isContactOnEdition,
  });

  const userInformation: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.businessInformation'),
    sections: [
      {
        component: (
          <KycInformationSection
            section={mainInformation}
            isOnEdition={isMainInformationOnEdition}
            sectionKey="main-information"
            isLoading={isLoading}
            isFormInvalid={isMainInformationInvalid}
            isSectionNotEditable={isSectionEditable('mainInformation')}
            onEdit={() => toogleSectionEditMode('mainInformation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('mainInformation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('mainInformation'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={contact}
            isOnEdition={isContactOnEdition}
            sectionKey="contact"
            isLoading={isLoading}
            isFormInvalid={isContactInvalid}
            isSectionNotEditable={isSectionEditable('contact')}
            onEdit={() => toogleSectionEditMode('contact')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('contact'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('contact'))}
          />
        ),
      },
    ],
  };
  return <SummaryInformation {...userInformation} key="userInformation" />;
}
